import DistributionWidget from './DistributionWidget';
export default DistributionWidget;



// WEBPACK FOOTER //
// ./src/components/widgetTypes/components/DistributionWidget/index.js